export const SkillsTypeList = [
  {
    id: 1,
    title: "HTML5 / CSS3",
    percentage: 85,
  },
  {
    id: 2,
    title: "Java Script",
    percentage: 70,
  },
  {
    id: 3,
    title: "React Js",
    percentage: 75,
  },
  {
    id: 4,
    title: "Next Js",
    percentage: 70,
  },
  {
    id: 5,
    title: "Chakra UI / Material UI / Bootstrap",
    percentage: 90,
  },
  {
    id: 8,
    title: "TypeScript",
    percentage: 70,
  },
  {
    id: 9,
    title: "GitHub",
    percentage: 65,
  },
  {
    id: 10,
    title: "Tailwind CSS",
    percentage: 85,
  },
]
